import React, {useRef} from "react"
import {useNavigateWithListPath} from "../../hooks/useListReturnPath"
import {Bill} from "../../resources/bills"
import {Meta, Resource} from "../../resources/common"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import {BillRow} from "./BillRow"
import {AllowedBillsColumns, BillsColumns} from "./Bills"

interface BillsTableProps {
	bills: Bill[]
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	include?: Resource[]
	includedColumns: AllowedBillsColumns[]
	meta?: Meta
	fullHeight?: boolean
	sortFunction: () => void
	sortBy: string
}

export function BillsTable({
	bills,
	fullHeight,
	includedColumns,
	hasNext,
	hasPrev,
	hasResults,
	isUsingPaging,
	include,
	meta,
	prev,
	next,
	sortFunction,
	sortBy,
}: BillsTableProps) {
	const navigateWithListPath = useNavigateWithListPath()
	const noContent = bills.length === 0
	const ref = useRef(null)

	return (
		<div ref={ref} className={"payments-table"}>
			<DataTable isEmpty={noContent} fullHeight={fullHeight} stickyAction={fullHeight} noContentText={"No bills found"}>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							if (column[1] === BillsColumns.createdAt) {
								return (
									<DataTableCell
										clickable
										onClick={() => sortFunction()}
										key={column[1]}
										sortable
										sortApplied={sortBy === "createdAt"}
									>
										{column[1]}
									</DataTableCell>
								)
							}

							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{bills.map((bill) => (
						<BillRow
							bill={bill}
							key={bill.id}
							include={include}
							onClick={(e) => {
								e.preventDefault()
								e.stopPropagation()
								navigateWithListPath(`/bills/${bill.id}`)
							}}
							includedColumns={includedColumns}
						/>
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
